import axios from "axios";

import { handleRedirect , parseQueryString } from "containers/utils";
import { getAuthToken } from "store/authConfig";
import * as actionTypes from "../actionTypes";
import { addToast } from '../../../components/Toast/actions';
// import base_url from "../../../../config/dev"



export const formIoAppStart = () => {
  return {
    type: actionTypes.FORM_IO_START
  };
};

export const formIoAppSuccess = (data) => {
  return {
    type: actionTypes.FORM_IO_SUCCESS,
    data: data
  };
};

export const formIoAppsError = (error) => {
  return {
    type: actionTypes.FORM_IO_ERROR,
    error: error
  };
};

export const formIoStore = (schema, id) => {
  return dispatch => {
    let data = { "content": schema }
    dispatch(formIoAppStart());
    getAuthToken()
    let redirect_url = handleRedirect(window.location.href,window.location.hash)
    axios.patch(`/api/forms/` + id, data)
      .then(() => {
        window.location.href = redirect_url
      })
      .catch(err => {
        console.log(err);
      });
  }

};
export const formIoEdit = () => dispatch =>
  new Promise((resolve, reject) => {
    dispatch(formIoAppStart());
    getAuthToken()
    let queryparams = parseQueryString(window.location.href)
    let key = queryparams.key
    let promsise = []
    promsise.push(axios.get(`/api/forms/modeler/${key}`))
    promsise.push(axios.get(`/api/forms?key=${key}`))
    axios.all(promsise)
      .then(res => {
        let data = []
         data.push(res[0].data.data)
         data.push(res[1].data)
         resolve(data);
      })
      .catch(err => {
        dispatch(formIoAppsError(err));
        reject(err)
      });
  })


export const formIoVersioning = (schema, dataContent,formStructure) => {
  return dispatch => {
    let data = {
      "content": schema,
      "name": dataContent.name,
      "description": dataContent.description,
      "key": dataContent.key_value
    }
    dispatch(formIoAppStart());
    getAuthToken()
    axios.post(`/api/forms/`, data)
      .then(()=> {
        dispatch(addToast('success', 'Success', 'Form Updated Successfully'))
        formStructure()
      })
      .catch(err => {
        console.log(err);
      });
  }

};

export const formIoStoreVersion = (schema, dataContent) => {
  return dispatch => {
    let data = {
      "content": schema,
      "name": dataContent.name,
      "description": dataContent.description,
      "key": dataContent.key_value
    }
    dispatch(formIoAppStart());
    getAuthToken()
    axios.patch(`/api/forms/` + dataContent.id, data)
      .then(() => {
        dispatch(addToast('success', 'Success', 'Form Updated Successfully'))
      })
      .catch(err => {
        console.log(err);
      });
  
      }  

};